import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-password-reset-success',
    templateUrl: './password-reset-success.component.html',
    styleUrls: ['./password-reset-success.component.scss'],
    standalone: false
})
export class PasswordResetSuccessComponent {
    constructor(private router: Router) { }

    onContinue(): void {
        localStorage.removeItem('jwt');
        localStorage.removeItem('tokenExpiration');
        this.router.navigate(['/login']);
    }
} 